export const USED_XOFILTEREDITOR = 'used XOFilterEditor';
export const CHANGED_ASSOCIATION = 'changed association';
export const USED_SEGMENTATION_FILTERS = 'used SegmentationFilters';